var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',[_c('Shadow',{attrs:{"config":_vm.shadow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }